import React, { FC, CSSProperties } from "react";

export interface AriaHiddenProps {
    as: "div" | "span" | React.ComponentClass;
    id?: string;
    className?: string;
    "data-testid"?: string;
    style?: CSSProperties | undefined;
}

const AriaHidden: FC<AriaHiddenProps> = ({ as: Component, ...props }: AriaHiddenProps) => {
    return <Component {...props} aria-hidden="true" />;
};

export default AriaHidden;
